/* eslint-disable import/no-cycle */
import BalanceSituacion from "features/Contabilidad/pages/BalanceSituacion/BalanceSituacion"
import PerdidasGanancias from "features/Contabilidad/pages/PerdidasGanancias/PerdidasGanancias"
import * as ROUTES from "routes/RoutePaths"
import SumasSaldos from "../SumasSaldos/SumasSaldos"

export const TAB_DOCUMENTOS_RECIBIDOS = "TAB_DOCUMENTOS_RECIBIDOS"

export const ESTADO_COLUMN = "ESTADO_COLUMN"

export const ESTADO_CESION = "cesionStatus"

export const TABS = (t: $TSMigrationFixMe) => [
  {
    key: ROUTES.CONTABILIDAD_BALANCE,
    header: `${t("informes.selectedTab.headerBalance")}`,
    Component: BalanceSituacion,
    id: 0,
  },
  {
    key: ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS,
    header: `${t("informes.selectedTab.headerProfitLoss")}`,
    Component: PerdidasGanancias,
    id: 1,
  },
  {
    key: ROUTES.CONTABILIDAD_SUMAS_SALDOS,
    header: `${t("informes.selectedTab.headerAdditionsBalances")}`,
    Component: SumasSaldos,
    id: 2,
  },
]
